import { Component, OnInit, Input, TemplateRef, SimpleChanges, ViewChild, ElementRef, ChangeDetectorRef } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { PmdModalRef, PmdModal , PmdModalService } from '../propeller/modal/index';
import { Subscription, combineLatest } from 'rxjs';
import { CONSTANTS } from 'src/app/core/config/constants';
import { AbstractControl, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { CommonService } from 'src/app/core/helper/common.service';
import { SupportService } from 'src/app/modules/support/support.service';
import { LocalStorageService } from 'src/app/core/helper/local-storage.service';
import { LayoutService } from 'src/app/layout/layout.service';


@Component({
  selector: 'help',
  templateUrl: './help.component.html',
  styleUrls: ['./help.component.css']
})
export class HelpComponent implements OnInit {
  CONSTANTS=CONSTANTS
  @ViewChild('helpModalTemplate') helpModalTemplateRef: PmdModal;
  modalRef: PmdModalRef;
  subscriptions: Subscription[] = [];
  supportTicketPriority = CONSTANTS.LOOKUP_DATA.SUPPORT_TICKET_PRIORITY;
  helpForm:FormGroup;
  submitted=false;
  attachedFilesArray=[];
  merchantInfo;
  helpDescriptionLength=500;
  helpDescriptionRemainingLength=500;

  constructor(private route: ActivatedRoute,
    private modalService: PmdModalService,
    private changeDetection: ChangeDetectorRef,
    private formBuilder: FormBuilder,
    public commonService: CommonService,
    private cd: ChangeDetectorRef,
    private supportService:SupportService,
    private localStorageService:LocalStorageService,
    private router:Router,
    private layoutService:LayoutService) { }

  ngOnInit() {
    this.merchantInfo=this.localStorageService.getUser();
    this.validateForm();
  }

  /**
   * validate form
   */
  validateForm() {
      this.helpForm = this.formBuilder.group(
        {
          helpMerchantName: [this.merchantInfo.firstname + ' ' + this.merchantInfo.lastname , [Validators.required]],
          helpMerchantPhone: [this.merchantInfo.mobilenumber, [Validators.required,Validators.minLength(8),Validators.required,Validators.maxLength(8)]],
          helpMerchantSubject: ['', [Validators.required]],
          helpMerchantPriority: [this.supportTicketPriority[2].id, [Validators.required]],
          helpMerchantText: ['', [Validators.required]],
        },
      );
    
  }

  /**
   * get form controls
   */
  get f(): { [key: string]: AbstractControl } {
    return this.helpForm.controls;
  }

  /**
   * submit form
   */
  submitForm(){
    this.submitted=true;
    if(this.helpForm.invalid){
      return false;
    }
    var responseDto = {
      name:this.helpForm.value.helpMerchantName,
      subject:this.helpForm.value.helpMerchantSubject,
      countrycode: 965,
      mobilenumber: this.helpForm.value.helpMerchantPhone,
      priority: this.helpForm.value.helpMerchantPriority,
      description:this.helpForm.value.helpMerchantText,
      attachments:this.attachedFilesArray
    }

    //prepare form data
    var formDataHelpDto: any = new FormData();
    for (var key in responseDto) {
      if (key == 'attachments') {
        for (let i = 0; i < responseDto[key].length; i++) {
          formDataHelpDto.append('attachments', responseDto[key][i])
        }
      } else {
        if (responseDto[key] !== null && responseDto[key] !== '') {
          formDataHelpDto.append(key, responseDto[key]);
        }
      }
    }

    this.supportService.postHelpQuery(formDataHelpDto).subscribe({
      next: (response) => {
        const statusCode = this.commonService.handleSubscribeNext(response);
        switch (statusCode) {
          case CONSTANTS.API.RESPONSE.STATUS_CODE.SUCCESS:
            this.commonService.toasterService(1, "Support Ticket has been raised successfully. You can track the request from Support module.");
            this.closeHelpModal();
            if(this.router.url === "/support/support-list"){
              window.location.reload();
            }
            break;
          default:
            console.log("default case executed response")
            break;
        }

      }
    })
  }

  /**
   * open help modal
   */
  openHelpModal(){
    this.helpModalTemplateRef.show();
    
  }

  /***
   * close help popup
   */
  closeHelpModal() {
    this.helpModalTemplateRef.hide();

    this.submitted=false;
    this.helpForm.reset();
    this.attachedFilesArray=[];
    this.validateForm();
    setTimeout(() => {
      Object.keys(this.helpForm.controls).forEach(key => {
        //this.helpForm.get(key).setErrors(null) ;
        this.helpForm.get(key).markAsPristine();
        this.helpForm.get(key).markAsUntouched();
        this.helpForm.get(key).updateValueAndValidity() ;
      });
      //this.helpForm.markAsPristine();
    //this.helpForm.markAsUntouched();
    //this.helpForm.updateValueAndValidity();
    }, 1000);
  }


  /**
   * file upload both type type form
   * @param event 
   * @param formType 
   */
  uploadFile(event) {
    const files = event.target.files;
    for (let i = 0; i < files.length; i++) {
      const file = files[i];
      const fileExists = this.attachedFilesArray.some(attachedFile => attachedFile.name === file.name);
      if (!fileExists) {
        var totalSizeMB = parseFloat((file.size / Math.pow(1024,2)).toFixed(2));
        if(totalSizeMB > 5){
          this.commonService.toasterService(0, "Allowed only JPG, JPEG, PNG & PDF files with a max file size of 5 MB.");
          event.target.value = '';
        }else{
          const url = URL.createObjectURL(file);
          this.attachedFilesArray.push(file)
        }
        
      } else {
        console.log(`File with the name ${file.name} is already attached.`);
      }
    }
    // Clear the input field
    event.target.value = '';
  }

  /**
   * remove attachment
   * @param file 
   */
  removeFile(file) {
    this.attachedFilesArray = this.attachedFilesArray.filter((item) => item.name !== file.name);
  }

  /**
   * display discription length information
   */
  displayLengthCounter(event){
    this.helpDescriptionRemainingLength=(this.helpDescriptionLength-event.target.value.length);
  }

  

}
